import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import announcer from './aria-announcer';

const elementMessage = "Carrousel d'éléments";
const nextElement = 'Élément suivant';
const prevElement = 'Élément précédent';
// Twig cannot output Swiper's {{placeholder}} syntax, so translated labels use %placeholder%
const toSwiperMessage = (label) => label.replace(/%(\w+)%/g, '{{$1}}');
const getAdjacentSlidesLabels = (el) => {
    const prevSlide = el.querySelector('.swiper-slide-prev');
    const nextSlide = el.querySelector('.swiper-slide-next');
    const prevLabel = prevSlide?.getAttribute('aria-label');
    const nextLabel = nextSlide?.getAttribute('aria-label');
    return { prevLabel, nextLabel };
};

document.addEventListener('DOMContentLoaded', () => {
    const $blockImageSwiper = document.querySelectorAll('.block-img-swiper');
    const updateSlideAccessibility = ({ slides, activeIndex }) => {
        slides.forEach((slide, index) => {
            const isActive = index === activeIndex;
            slide.setAttribute('tabindex', isActive ? '0' : '-1');
            slide.setAttribute('aria-hidden', (!isActive).toString());
        });
    };

    $blockImageSwiper.forEach((el) => {
        const btnPrev = el.querySelector('.button-swiper-prev');
        const btnNext = el.querySelector('.button-swiper-next');

        // eslint-disable-next-line no-new
        new Swiper(el, {
            modules: [Navigation, A11y],
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 8,
            loop: true,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            breakpoints: {
                1024: {
                    spaceBetween: 32,
                },
            },
            on: {
                init: (element) => {
                    updateSlideAccessibility(element);
                },
                slideChangeTransitionEnd: (element) => {
                    updateSlideAccessibility(element);
                },
            },
            a11y: {
                enabled: true,
                containerMessage: elementMessage,
                prevSlideMessage: prevElement,
                nextSlideMessage: nextElement,
                paginationBulletMessage: "Aller à l'élément {{index}}",
            },
        });

        btnNext.addEventListener('click', () => {
            const { nextLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Élément suivant ${nextLabel}`);
        });

        btnPrev.addEventListener('click', () => {
            const { prevLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Élément précédent ${prevLabel}`);
        });
    });

    const $heroHomeCarousels = document.querySelectorAll('.hero-home-carousel');

    $heroHomeCarousels.forEach(($carousel) => {
        const $swiper = $carousel.querySelector('.swiper');
        const $slides = $swiper.querySelectorAll('.swiper-slide');
        const {
            labelContainer, labelPrev, labelNext, labelSlide, labelBullet,
        } = $carousel.dataset;
        // Swiper loop needs more slides than can be visible at once (wide screens show more)
        const visibleSlides = Math.ceil($swiper.clientWidth / $slides[0].offsetWidth);
        const canLoop = $slides.length > visibleSlides;

        // eslint-disable-next-line no-new
        new Swiper($swiper, {
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 'auto',
            spaceBetween: 2,
            speed: 700,
            loop: canLoop,
            rewind: !canLoop,
            navigation: {
                nextEl: $carousel.querySelector('.btn-swiper-next'),
                prevEl: $carousel.querySelector('.btn-swiper-prev'),
            },
            pagination: {
                el: $carousel.querySelector('.pagination-swiper'),
                clickable: true,
                bulletElement: 'button',
            },
            breakpoints: {
                1024: {
                    spaceBetween: 4,
                },
            },
            a11y: {
                enabled: true,
                containerMessage: labelContainer,
                prevSlideMessage: labelPrev,
                nextSlideMessage: labelNext,
                slideLabelMessage: toSwiperMessage(labelSlide),
                paginationBulletMessage: toSwiperMessage(labelBullet),
            },
        });
    });

    // Carousel on mobile and tablet, grid from the large breakpoint
    const $gridCarousels = document.querySelectorAll(
        '.block-cards-grid-carousel, .block-articles-carousel',
    );
    const gridDesktop = window.matchMedia('(min-width: 1024px)');

    $gridCarousels.forEach(($carousel) => {
        const $swiper = $carousel.querySelector('.swiper');
        const {
            labelContainer, labelPrev, labelNext, labelSlide, labelBullet,
        } = $carousel.dataset;
        let swiper = null;

        const toggleSwiper = () => {
            if (gridDesktop.matches) {
                swiper?.destroy(true, true);
                swiper = null;
            } else if (!swiper) {
                swiper = new Swiper($swiper, {
                    modules: [Navigation, Pagination, A11y],
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 600,
                    navigation: {
                        nextEl: $carousel.querySelector('.btn-swiper-next'),
                        prevEl: $carousel.querySelector('.btn-swiper-prev'),
                    },
                    pagination: {
                        el: $carousel.querySelector('.pagination-swiper'),
                        clickable: true,
                        bulletElement: 'button',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                    },
                    a11y: {
                        enabled: true,
                        containerMessage: labelContainer,
                        prevSlideMessage: labelPrev,
                        nextSlideMessage: labelNext,
                        slideLabelMessage: toSwiperMessage(labelSlide),
                        paginationBulletMessage: toSwiperMessage(labelBullet),
                    },
                });
            }
        };

        toggleSwiper();
        gridDesktop.addEventListener('change', toggleSwiper);
    });
});
